import { DialogActions, DialogContent } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { NotificationActionsPayload } from 'shared/store/useNotifications/types'
import ContainedButton from 'shared/components/Buttons/ContainedButton'
import { useRemoveNotification } from 'shared/store/useNotifications'
import OutlinedButton from 'shared/components/Buttons/OutlinedButton'

interface Props {
   notificationUuid?: string
   handleClose: () => void
}

export default function DeleteNotification({ notificationUuid, handleClose }: Props) {
   const { t } = useTranslation(['TRANSLATION', 'NOTIFICATIONS'])
   const { mutate, isLoading } = useRemoveNotification()

   function handleRemove() {
      if (notificationUuid) {
         const payload: NotificationActionsPayload = { uuid: notificationUuid }
         mutate(payload, {
            onSettled: handleClose,
         })
      }
   }

   return (
      <>
         <DialogContent>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
               {t('NOTIFICATIONS:deleteText')}
            </Typography>
         </DialogContent>
         <DialogActions>
            <OutlinedButton variant="outlined" onClick={handleClose}>
               {t('TRANSLATION:cancel')}
            </OutlinedButton>
            <ContainedButton disabled={isLoading} variant="contained" onClick={handleRemove}>
               {t('TRANSLATION:delete')}
            </ContainedButton>
         </DialogActions>
      </>
   )
}
